import React from "react";
import {
  SEO,
  PageLayout,
  Map,
  LocationsSorted,
  SocialMedia,
  ContactForm,
} from "@bluefin/components";
import { Grid, Header } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class LocationsPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
        />
        <PageLayout
          className={"contact-page"}
          hero={
            <Map
              address={{
                street: fishermanBusiness.primaryLocation.street,
                city: fishermanBusiness.primaryLocation.city,
                state: fishermanBusiness.primaryLocation.state,
                zip: fishermanBusiness.primaryLocation.zipCode,
              }}
            />
          }
        >
          <Grid stackable={true} columns={1}>
            <Grid.Column>
              <LocationsSorted
                locations={fishermanBusiness.locations}
                searchHeader={"Locations"}
                searchHeaderAs={"h1"}
                showIcons={false}
              />
            </Grid.Column>
          </Grid>
          <Grid stackable={true}>
            <Grid.Column width={4}>
              <SocialMedia
                socialMediaValues={fishermanBusiness.socialMedia}
                buttonType={"circle"}
                centerHeader={false}
                colors={""}
                groupButtons={false}
                groupVertically={false}
                header={<Header as={"h5"}>EDINBURG LOCATION</Header>}
                inverted={true}
                labelPosition={"free"}
                showLabels={false}
              />
            </Grid.Column>
            <Grid.Column width={8}>
              <ContactForm
                buttonText={"Send"}
                centeredHeaders={true}
                className={""}
                fluidButton={true}
                header={"Contact Us"}
                inline={false}
                showLabels={true}
                subheader={""}
                termsCopy={""}
                withContainer={true}
                locationId={fishermanBusiness.primaryLocation._id}
                businessId={fishermanBusiness._id}
                businessType={fishermanBusiness.type}
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <SocialMedia
                socialMediaValues={[
                  {
                    type: "instagram",
                    link: "https://www.instagram.com/nails2tailsmission/",
                  },
                  {
                    type: "facebook",
                    link: "https://www.facebook.com/nails2tailsmission/",
                  },
                ]}
                buttonType={"circle"}
                centerHeader={false}
                colors={"secondary"}
                groupButtons={false}
                groupVertically={false}
                header={
                  <Header as={"div"} className={"h5"}>
                    Mission Location
                  </Header>
                }
                inverted={false}
                labelPosition={"free"}
                showLabels={false}
              />
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      primaryLocation {
        street
        city
        state
        zipCode
        _id
      }
      locations {
        phoneNumber
        name
        email
        street
        city
        state
        zipCode
        hours {
          day
          open
          close
          label
        }
        _id
      }
      socialMedia {
        link
        type
      }
      _id
      type
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Contact" }) {
      title
    }
  }
`;
